export default "__VITE_ASSET__DOH8UVZq__"